// Constants.
// -----------------------------------------------------------------------------
// Default values.
export const DEFAULT_TEXT_ALIGN = 'inherit';
export const DEFAULT_TEXT_BOLD = false;
export const DEFAULT_TEXT_IS_CHILDREN = false;
export const DEFAULT_TEXT_SIZE = 'm';
export const DEFAULT_TEXT_UPPERCASE = false;
//# sourceMappingURL=Text.constants.js.map